import "./Sidebar.scss";
import { Link, NavLink, useNavigate, useLocation } from "react-router-dom";
/* eslint-disable unicode-bom */
import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHouse,
  faUser,
  faEnvelope,
  faCode,
  faBriefcase,
  faDiagramProject,
  faMedal,
} from "@fortawesome/free-solid-svg-icons";
import {
  faLinkedin,
  faGithub,
} from "@fortawesome/free-brands-svg-icons";

function Sidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    setIsMenuOpen(false);
  }, [location.pathname]);

  const goHome = (e) => {
    e.preventDefault();
    const container = document.querySelector(".main-scroll-container");
    if (location.pathname === "/") {
      // already on home route — just scroll to top
      if (container) {
        container.scrollTo({ top: 0, behavior: "smooth" });
      }
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      navigate("/");
    }

    setIsMenuOpen(false);
  };

  const isMobileViewport = () =>
    typeof window !== "undefined" && window.matchMedia("(max-width: 768px)").matches;

  const scrollToSection = (selector, attempt = 0) => {
    const container = document.querySelector(".main-scroll-container");
    const target = container?.querySelector(selector) || document.querySelector(selector);

    if (!target) {
      if (attempt < 8) {
        setTimeout(() => scrollToSection(selector, attempt + 1), 80);
      }
      return;
    }

    const canUseContainer =
      container && container.scrollHeight > container.clientHeight + 2;

    if (canUseContainer) {
      const containerTop = container.getBoundingClientRect().top;
      const targetTop = target.getBoundingClientRect().top;
      const scrollTo = container.scrollTop + (targetTop - containerTop);

      container.scrollTo({ top: scrollTo, behavior: "smooth" });
      return;
    }

    const documentTop = window.scrollY + target.getBoundingClientRect().top;
    window.scrollTo({ top: documentTop - 68, behavior: "smooth" });
  };

  const handleSectionNav = (selector) => (e) => {
    if (!isMobileViewport()) {
      return;
    }

    e.preventDefault();
    setIsMenuOpen(false);

    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => scrollToSection(selector), 100);
      return;
    }

    scrollToSection(selector);
  };

  const linkClassName = ({ isActive }) => (isActive ? "active" : "");

  return (
    <div className="nav-bar">
      <div className="mobile-nav-head">
        <Link className="mobile-brand" to="/" onClick={goHome}>
          AR
        </Link>
        <button
          type="button"
          className={`menu-toggle ${isMenuOpen ? "is-open" : ""}`}
          aria-label="Toggle navigation menu"
          aria-expanded={isMenuOpen}
          onClick={() => setIsMenuOpen((prev) => !prev)}
        >
          <span />
          <span />
          <span />
        </button>
      </div>

      <Link className="logo" to="/" onClick={goHome}>
        <div className="logo-text">AR</div>
        <div className="logo-sub">Anuj Rathore</div>
        <div className="logo-role">Full Stack Dev</div>
      </Link>
      <nav className={isMenuOpen ? "open" : ""}>
        <div className="nav-item">
          <NavLink className={linkClassName} to="/" onClick={goHome}>
            <FontAwesomeIcon icon={faHouse} color="#4d4d4e" />
            <span className="nav-label">Home</span>
          </NavLink>
          <div className="horizontal-line" />
        </div>
        <div className="nav-item">
          <NavLink
            className={({ isActive }) => `${linkClassName({ isActive })} about-link`.trim()}
            to="/about"
            onClick={handleSectionNav(".about-page")}
          >
            <FontAwesomeIcon icon={faUser} color="#4d4d4e" />
            <span className="nav-label">About</span>
          </NavLink>
          <div className="horizontal-line" />
        </div>
        <div className="nav-item">
          <NavLink
            className={({ isActive }) => `${linkClassName({ isActive })} skill-link`.trim()}
            to="/skill"
            onClick={handleSectionNav(".skill-page")}
          >
            <FontAwesomeIcon icon={faCode} color="#4d4d4e" />
            <span className="nav-label">Skills</span>
          </NavLink>
          <div className="horizontal-line" />
        </div>
        <div className="nav-item">
          <NavLink
            className={({ isActive }) => `${linkClassName({ isActive })} experience-link`.trim()}
            to="/experience"
            onClick={handleSectionNav(".experience-page")}
          >
            <FontAwesomeIcon icon={faBriefcase} color="#4d4d4e" />
            <span className="nav-label">WorkEx</span>
          </NavLink>
          <div className="horizontal-line" />
        </div>
        <div className="nav-item">
          <NavLink
            className={({ isActive }) => `${linkClassName({ isActive })} project-link`.trim()}
            to="/project"
            onClick={handleSectionNav(".project-page")}
          >
            <FontAwesomeIcon icon={faDiagramProject} color="#4d4d4e" />
            <span className="nav-label">Projects</span>
          </NavLink>
          <div className="horizontal-line" />
        </div>
        <div className="nav-item">
          <NavLink
            className={({ isActive }) => `${linkClassName({ isActive })} achievements-link`.trim()}
            to="/achievements"
            onClick={handleSectionNav(".achievements-page")}
          >
            <FontAwesomeIcon icon={faMedal} color="#4d4d4e" />
            <span className="nav-label">Achievements</span>
          </NavLink>
          <div className="horizontal-line" />
        </div>
        <div className="nav-item">
          <NavLink
            className={({ isActive }) => `${linkClassName({ isActive })} contact-link`.trim()}
            to="/contact"
            onClick={handleSectionNav(".contact-page")}
          >
            <FontAwesomeIcon icon={faEnvelope} color="#4d4d4e" />
            <span className="nav-label">Contact</span>
          </NavLink>
        </div>
      </nav>
      <ul>
        <li>
          <a
            className="svg-B"
            href="https://www.linkedin.com/in/anuj-rathore-a01960272/"
            target="_blank"
            rel="noreferrer"
          >
            <FontAwesomeIcon icon={faLinkedin} color="#4d4d4e" />
          </a>
        </li>
        <li>
          <a
            className="svg-B"
            href="https://github.com/rathoreanuj"
            target="_blank"
            rel="noreferrer"
          >
            <FontAwesomeIcon icon={faGithub} color="#4d4d4e" />
          </a>
        </li>
      </ul>
    </div>
  );
}

export default Sidebar;